import React from 'react';
import { Tooltip, Button } from 'antd';
import cn from 'classnames';
import InfoBlock from '../../../../../components/InfoBlock/InfoBlock';
import getName from '../../../../../../../helpers/getName';
import moment from 'moment';
import styles from '../RoomBlock.module.scss';

const Tenant = ({
  tenant = {},
  onEditBtnClick,
  onRemoveBtnClick,
  removeTooltipTitle = 'Удалить или завершить договор аренды',
}) => {
  return (
    <InfoBlock className={styles.tenantCard}>
      <div className={styles.tenantDataContainer}>
        <p className={cn(styles.text, styles.mainText)}>
          {tenant.name ? tenant.name : getName(tenant)}
        </p>
        {tenant.account && (
          <p className={cn(styles.text, styles.secondaryText)}>
            <span style={{ fontWeight: 700 }}>ЛС:</span> {`${tenant.account}`}
          </p>
        )}

        {tenant.accountStartDate && (
          <p className={cn(styles.text, styles.secondaryText)}>
            <span style={{ fontWeight: 700 }}>Начало аренды:</span>{' '}
            {`${moment(tenant.accountStartDate).format('DD.MM.YYYY')}`}
          </p>
        )}
        {tenant.accountEndDate && (
          <p className={cn(styles.text, styles.secondaryText)}>
            <span style={{ fontWeight: 700 }}>Конец аренды:</span>{' '}
            {`${moment(tenant.accountEndDate).format('DD.MM.YYYY')}`}
          </p>
        )}
      </div>
      <div className={styles.tenantActionsContainer}>
        {typeof onEditBtnClick === 'function' && (
          <Tooltip title="Изменить данные">
            <Button
              className={styles.tenantAction}
              icon="edit"
              onClick={() => onEditBtnClick(tenant)}
            />
          </Tooltip>
        )}
        {typeof onRemoveBtnClick === 'function' && (
          <Tooltip title={removeTooltipTitle}>
            <Button
              className={styles.tenantAction}
              icon="minus-circle"
              onClick={() => onRemoveBtnClick(tenant)}
            />
          </Tooltip>
        )}
      </div>
    </InfoBlock>
  );
};

export default Tenant;
